import { doHttp } from '../utils/common'
import { HTTP_TYPE_GET, HTTP_TYPE_POST, CONTENT_TYPE_FORM } from '../utils/config'

/**
 * 新增
 * @param params
 * @param flag
 * @return {*}
 */
export function apiAdd (params, flag = 0) {
  return doHttp(`/organization/add.action?flag=${flag}`, HTTP_TYPE_POST, params)
}

/**
 * 编辑组织
 * @param params
 * @return {*}
 */
export function apiEdit (params) {
  return doHttp('/organization/addOrUpdate.action', HTTP_TYPE_POST, params)
}

/**
 * 禁用
 * @param id
 * @return {*}
 */
export function apiSwitchStatus (id) {
  let params = {
    id,
    flag: 1
  }
  return doHttp('/organization/delete.action', HTTP_TYPE_GET, params)
}

/**
 * 删除
 * @param id
 * @return {*}
 */
export function apiDelete (id) {
  let params = {
    id,
    flag: 2
  }
  return doHttp('/organization/delete.action', HTTP_TYPE_GET, params)
}

/**
 * 详情
 * @param id
 * @return {*}
 */
export function apiDetail (id) {
  let params = {
    id,
    flag: 2
  }
  return doHttp('/organization/detail.action', HTTP_TYPE_GET, params)
}

/**
 * 列表
 * @param {*} name
 * @param {*} status 0:未禁用 1:已禁用
 * @param {*} pageIndex
 * @param {*} pageSize
 * @return {*}
 */
export function apiList (name, status, pageIndex = 1, pageSize = 20) {
  let params = {
    name,
    status,
    pageIndex,
    pageSize
  }
  return doHttp('/organization/list.action', HTTP_TYPE_GET, params)
}

/**
 * 组织树
 * @return {*}
 */
export function apiTree () {
  return doHttp('/organization/tree.action', HTTP_TYPE_GET)
}

/**
 * 许可证列表
 * @param {*} companyId
 * @param {*} origin 来源 1分公司 2委托公司
 * @return {*}
 */
export function apiLicense (companyId, origin) {
  let params = {
    companyId,
    origin
  }
  return doHttp('/organization/license.action', HTTP_TYPE_GET, params)
}

/**
 * 新增许可证
 * @param {*} companyId
 * @param {*} number
 * @return {*}
 */
export function apiLicenseAdd (companyId, number) {
  let params = {
    companyId,
    number
  }
  return doHttp('/organization/license/add.action', HTTP_TYPE_GET, params)
}

/**
 * 批次生成方式切换
 * @param {*} id
 * @return {*}
 */
 export function batchChange (id) {
  let params = {
    id
  }
  return doHttp('/organization/change.action', HTTP_TYPE_GET, params)
}
